import {
  FaReact, FaPython, FaJava, FaPhp, FaJsSquare, FaDatabase, FaNodeJs, FaCode
} from 'react-icons/fa';
import {
  SiTailwindcss, SiLinux, SiDocker, SiPostman, SiNextdotjs, SiGraphql,
  SiGithub, SiJunit5, SiJest, SiSlack, SiNestjs,
  SiWebpack, SiMarkdown, SiJavascript, SiWordpress
} from 'react-icons/si';

const experienceData = [
  {
    role: "Front-End Software Developer",
    company: "Perry Johnson, Inc",
    location: "Troy, MI",
    duration: "Jul 2024 – Present",
    tasks: [
      (
        <>
          Own front-end delivery for five production marketing websites built on Next.js, React, TypeScript, and headless WordPress, sharing a common component architecture and delivery pipeline across the estate (including the PJR corporate site rebuild, from{" "}
          <a
            href="https://web.archive.org/web/20250908160647/https:/www.pjr.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 underline"
          >
            this
          </a>{" "}
          to{" "}
          <a
            href="https://www.pjr.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 underline"
          >
            this
          </a>
          ).
        </>
      ),
      "Shipped multilingual editions with App Router localization across English, Spanish, Canadian French, and Italian, covering localized content, forms, redirects, and international SEO.",
      "Improved performance substantially across the estate: 10x or better server response times through caching and connection-handling fixes, and 40%+ faster page loads through server rendering, image optimization, and bundle reduction.",
      "Hardened the sites against abuse and vulnerability: eliminated form spam across four properties, improved input sanitization, and ran an ongoing dependency security-update program.",
      "Led incident response on a production outage, diagnosing the root cause in the content layer rather than the application, restoring service and preventing recurrence.",
      "Lead front-end development of the company's internal audit-management platform (Next.js, React, NestJS, SQL Server): role-based dashboards, audit reporting, review and approval workflows, document management, and notifications.",
      "Designed and built the platform's visual form builder, giving non-technical staff drag-and-drop authoring of complex audit forms with conditional logic, versioning, change history, and live preview.",
      "Internationalized the platform across 16 locales with automated parity checks in CI, and expanded automated test coverage including end-to-end and accessibility testing.",
      "Contribute across the stack to the NestJS API, ORM layer, and SQL Server procedures supporting auditing, file handling, and work prioritization.",
      "Implement technical SEO and analytics integrations, and maintain the delivery pipeline: continuous integration, code review, automated releases, and cloud deployments.",
    ],
    tech: [
      { name: "React", icon: FaReact, color: "bg-[#1f2937]" },
      { name: "Next.js", icon: SiNextdotjs, color: "bg-[#111827]" },
      { name: "TypeScript", icon: FaCode, color: "bg-[#3b82f6]" },
      { name: "Tailwind CSS", icon: SiTailwindcss, color: "bg-[#0ea5e9]" },
      { name: "Node.js", icon: FaNodeJs, color: "bg-[#68A063]" },
      { name: "NestJS", icon: SiNestjs, color: "bg-[#991b1b]" },
      { name: "GraphQL", icon: SiGraphql, color: "bg-[#E10098]" },
      { name: "SQL Server", icon: FaDatabase, color: "bg-[#64748b]" },
      { name: "Headless WordPress", icon: SiWordpress, color: "bg-[#21759b]" },
      { name: "REST API", icon: null, color: "bg-[#6b7280]" },
      { name: "i18n", icon: null, color: "bg-[#0f766e]" },
      { name: "Accessibility", icon: null, color: "bg-[#0e7490]" },
      { name: "Automated Testing", icon: null, color: "bg-[#4b5563]" },
      { name: "CI/CD", icon: null, color: "bg-[#1e293b]" },
      { name: "Azure", icon: null, color: "bg-[#2563eb]" },
      { name: "GitHub", icon: SiGithub, color: "bg-[#171515]" },
      { name: "WP Engine", icon: null, color: "bg-[#0ea5e9]" },
      { name: "SEO", icon: null, color: "bg-[#10b981]" },
      { name: "Application Security", icon: null, color: "bg-[#334155]" },
      { name: "Agile", icon: null, color: "bg-[#10b981]" },
      { name: "HTML/CSS", icon: FaCode, color: "bg-[#4b5563]" },
    ]
  },

  {
    role: "Full Stack Web Developer",
    company: "Education Management & Networks Inc",
    location: "Southfield, MI",
    duration: "Nov 2020 – Jul 2024",
    tasks: [
      "Built and maintained websites for three schools using React, Next.js, JavaScript, and WordPress, delivering responsive interfaces for students, parents, and administrators.",
      "Developed reusable UI components in TypeScript and Tailwind CSS, and customized WordPress with Advanced Custom Fields so school staff could update content without developer help.",
      "Integrated REST and GraphQL APIs, Node.js services, and MySQL data for dynamic content and internal workflows; migrated legacy WordPress implementations to a headless architecture.",
      "Implemented technical SEO, schema markup, and deployment workflows while collaborating with designers and marketing on features, branding, and releases.",
    ],
    tech: [
      { name: "React", icon: FaReact, color: "bg-[#1f2937]" },
      { name: "Next.js", icon: SiNextdotjs, color: "bg-[#000000]" },
      { name: "TypeScript", icon: FaCode, color: "bg-[#3b82f6]" },
      { name: "Tailwind CSS", icon: SiTailwindcss, color: "bg-[#0ea5e9]" },
      { name: "JavaScript", icon: FaJsSquare, color: "bg-[#facc15]" },
      { name: "Node.js", icon: FaNodeJs, color: "bg-[#68A063]" },
      { name: "GraphQL", icon: SiGraphql, color: "bg-[#E10098]" },
      { name: "PHP", icon: FaPhp, color: "bg-[#6b7280]" },
      { name: "MySQL", icon: FaDatabase, color: "bg-[#64748b]" },
      { name: "HTML/CSS", icon: FaCode, color: "bg-[#4b5563]" },
      { name: "WordPress", icon: SiWordpress, color: "bg-[#21759b]" },
      { name: "Advanced Custom Fields", icon: null, color: "bg-[#1e40af]" },
      { name: "Postman", icon: SiPostman, color: "bg-[#ff6c37]" },
      { name: "REST API", icon: null, color: "bg-[#6b7280]" },
      { name: "CI/CD", icon: null, color: "bg-[#1e293b]" },
      { name: "SEO", icon: null, color: "bg-[#10b981]" },
      { name: "Web Dev", icon: null, color: "bg-[#1e293b]" },
      { name: "UI/UX", icon: null, color: "bg-[#1e293b]" },
      { name: "Agile", icon: null, color: "bg-[#10b981]" },
    ]
  },
  {
    role: "Software Engineering Intern",
    company: "Colorado State University",
    location: "Fort Collins, CO",
    duration: "Jan 2024 – May 2024",
    tasks: [
      "Developed a full-stack online chess platform with real-time gameplay and user auth.",
      "Built RESTful APIs and mobile apps using Java, React, and Docker.",
      "Practiced Agile methodologies (Scrum), CI/CD, and test-driven development.",
      "Created a weather system using Python, Flask, and Raspberry Pi with BME688 sensor.",
      "Integrated real-time sensor data display with modern frontend frameworks."
    ],
    tech: [
      // Languages & Frameworks
      { name: "React", icon: FaReact, color: "bg-[#1f2937]" },
      { name: "Java", icon: FaJava, color: "bg-[#f97316]" },
      { name: "JavaScript", icon: SiJavascript, color: "bg-[#facc15]" },
      { name: "Python", icon: FaPython, color: "bg-[#4b5563]" },
      { name: "MySQL", icon: FaDatabase, color: "bg-[#64748b]" },
      { name: "Tailwind CSS", icon: SiTailwindcss, color: "bg-[#0ea5e9]" },

      // Tools
      { name: "GitHub", icon: SiGithub, color: "bg-[#171515]" },
      { name: "Postman", icon: SiPostman, color: "bg-[#ff6c37]" },
      { name: "JUnit", icon: SiJunit5, color: "bg-[#34d399]" },
      { name: "Jest", icon: SiJest, color: "bg-[#991b1b]" },
      { name: "Docker", icon: SiDocker, color: "bg-[#0db7ed]" },
      { name: "Linux", icon: SiLinux, color: "bg-[#111827]" },
      { name: "Slack", icon: SiSlack, color: "bg-[#4f46e5]" },
      { name: "ZenHub", icon: null, color: "bg-[#3b82f6]" },
      { name: "Code Climate", icon: null, color: "bg-[#1e3a8a]" },
      { name: "VS Code", icon: FaCode, color: "bg-[#2563eb]" },
      { name: "Markdown", icon: SiMarkdown, color: "bg-[#4b5563]" },
      { name: "Maven", icon: FaCode, color: "bg-[#ea580c]" },
      { name: "Webpack", icon: SiWebpack, color: "bg-[#60a5fa]" },
      { name: "Node.js", icon: FaNodeJs, color: "bg-[#3b82f6]" },

      // Concepts
      { name: "Clean Code", icon: null, color: "bg-[#334155]" },
      { name: "TDD", icon: null, color: "bg-[#4b5563]" },
      { name: "CI/CD", icon: null, color: "bg-[#1e293b]" },
      { name: "REST API", icon: null, color: "bg-[#6b7280]" },
      { name: "Concurrency", icon: null, color: "bg-[#475569]" },
      { name: "OOP", icon: null, color: "bg-[#64748b]" },
      { name: "Web Dev", icon: null, color: "bg-[#1e293b]" },
      { name: "Agile", icon: null, color: "bg-[#10b981]" }
    ]
  }
];

export default experienceData;
